import {ProjectDetails} from 'common/report/stores/project-details';

export function isNewUserPage(_project: ProjectDetails) {
  // TODO remove this function when comfortable with GA
  return true;
}
